import script from "./Booking.vue?vue&type=script&setup=true&lang=ts"
export * from "./Booking.vue?vue&type=script&setup=true&lang=ts"

import "./Booking.vue?vue&type=style&index=0&id=3e47c674&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e47c674"]])

export default __exports__